import Vue from 'vue'
import Vuex from 'vuex'

import i18n from '@/store/modules/i18n'
import theme from '@/store/modules/theme'
import projects from '@/store/modules/projects'
import nav from '@/store/modules/nav'
import team from '@/store/modules/team'
import contact from '@/store/modules/contact'
import about from '@/store/modules/about'
import home from '@/store/modules/home'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    i18n,
    theme,
    projects,
    nav,
    team,
    contact,
    about,
    home
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js